import Scheduler from "./Scheduler";
import SchedulerMusicHall from "./SchedulerMusicHall";
import Standard from "./Standard";
import TableAccounting from "./TableAccounting";
import TableBookingReserve from "./TableBookingReserve";
import TableNormal from "./TableNormal";

const EXPORT = {
  Scheduler,
  SchedulerMusicHall,
  Standard,
  TableNormal,
  TableAccounting,
  TableBookingReserve,
};

export default EXPORT;
